class MobileExplainer extends HTMLElement {
  constructor() {
    super();
    const toggle = this.querySelector(".js-mobile-explainer-toggle");
    const modal = this.querySelector(".modal");
    const close = this.querySelector(".js-close");
    if (toggle && modal) {
      toggle.addEventListener("click", () => {
        modal.classList.add("active");
      });
      close.addEventListener("click", () => {
        modal.classList.remove("active");
      });
    }
  }
}
if (customElements.get("mobile-explainer") === void 0) {
  customElements.define("mobile-explainer", MobileExplainer);
}
